import {atom, selector} from "recoil";
import {EDCategory} from "../../models/serverModels/education/EDCategory";
import {ResponseList} from "../../models/clientModels/interfaces/Response";

export const categoryListAtom = atom<ResponseList<EDCategory>>({
  key: "categoryListAtom",
  default: {} as ResponseList<EDCategory>,
});

export const middleCategoryIdState = atom<number>({
  key: "middleCategoryIdState",
  default: 0,
});
